var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":_vm.name,"height":_vm.height}}),_vm._v(" "),_c('div',{staticClass:"axis"},_vm._l((_vm.data.labels),function(x,key){return _c('div',{key:x,staticClass:"tick"},[_vm._v("\n      "+_vm._s(x)+"\n      "),_c('span',{staticClass:"value value--this"},[_vm._v(_vm._s(_vm.data.datasets[0].data[key]))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58862713","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/MonthlyChart.vue
// module id = null
// module chunks = 